// extracted by mini-css-extract-plugin
export default {"video-section":"p_bn d-flex","video-section--header":"p_bp","video-section__frame":"p_bq ml-3"};